import { render, staticRenderFns } from "./caseEdit.vue?vue&type=template&id=f3591494&scoped=true"
import script from "./caseEdit.vue?vue&type=script&lang=js"
export * from "./caseEdit.vue?vue&type=script&lang=js"
import style0 from "./caseEdit.vue?vue&type=style&index=0&id=f3591494&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3591494",
  null
  
)

export default component.exports